import axiosInstance from '../auth/AuthUserService.js'

export default class FornecedoresService {

  getAll() {
    const url = '/fornecedores/listar';
    return axiosInstance.get(url);
  }

  getLast() {
    const url = '/fornecedores/listar/last';
    return axiosInstance.get(url);
  }

  get(id) {
    const url = `/fornecedores/${id}`;
    return axiosInstance.get(url);
  }

  create(data) {
    const url = '/fornecedores/adicionar';
    return axiosInstance.post(url, data);
  }

  update(id, data) {
    const url = `/fornecedores/atualizar/${id}`;
    return axiosInstance.put(url, data);
  }

  delete(id) {
    const url = `/fornecedores/excluir/${id}`;
    return axiosInstance.delete(url);
  }

  getPrazosEntregaByFornecedor(id) {
    const url = `/fornecedores/prazo-entrega/listar/${id}`;
    return axiosInstance.get(url)
  }

  createPrazoEntrega(id, data) {
    const url = `/fornecedores/prazo-entrega/adicionar/${id}`;
    return axiosInstance.post(url, data)
  }

  deletePrazoEntrega(id) {
    const url = `/fornecedores/prazo-entrega/excluir/${id}`;
    return axiosInstance.delete(url)
  }

}